import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _MenuIcon, _IngramLogoWithoutR, _IngramLogoWithoutR2, _SearchIcon;
import React, { useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import MenuIcon from '@mui/icons-material/Menu';
import { IngramLogoWithoutR } from '../icons/IngramLogoWithoutR';
import { useLocalization, useTranslate } from '@im/react-localization';
import { Link, useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { SearchTextField } from '../SearchTextField';
import { removeLsObject } from '@im/ui-lib/utils/local-storage.utils';
import Popper from '@mui/material/Popper';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function HeaderX4CMobile(props) {
  var _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    _props$enableAISugges = props.enableAISuggestions,
    enableAISuggestions = _props$enableAISugges === void 0 ? false : _props$enableAISugges,
    getSearchSuggestions = props.getSearchSuggestions,
    _props$isLogoClickabl = props.isLogoClickable,
    isLogoClickable = _props$isLogoClickabl === void 0 ? true : _props$isLogoClickabl,
    onMenuButtonClick = props.onMenuButtonClick,
    sx = props.sx;
  var ariaLabelTranslate = useTranslate();
  var _useLocalization = useLocalization(),
    translate = _useLocalization.translate;
  var navigate = useNavigate();
  var theme = useTheme();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSeachBar = _useState2[0],
    setShowSeachBar = _useState2[1];
  var categories = ['Products', 'Bundle', 'Vendor Store', 'My Ingram Micro', 'Promotions', 'Resources'];
  function onSearch(value) {
    setShowSeachBar(false);
    return new Promise(function (resolve, reject) {
      try {
        var _value$source;
        var queryParam = value.searchType;
        var url = encodeURIComponent("".concat(value.text));
        var source = (_value$source = value.source) != null ? _value$source : '';
        var sourceParam = source !== '' ? "&source=".concat(source) : '';
        removeLsObject('selectedTab');
        removeLsObject('DisableSuggestionSearch');
        navigate("/product/productsearch?".concat(queryParam, "=").concat(url, "&displaytitle=").concat(url, "&sortBy=relevance").concat(sourceParam));
        resolve(true);
      } catch (e) {
        resolve(false);
      }
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(RootStack, {
      direction: "row",
      sx: sx,
      "data-element": "RootStack",
      "data-source-file": "HeaderX4CMobile.tsx",
      children: showSeachBar ? /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        spacing: "8px",
        width: "100%",
        children: [/*#__PURE__*/_jsx(SearchTextField, {
          PopperComponent: function PopperComponent(props) {
            return /*#__PURE__*/_jsx(StyledPopper, _extends({}, props));
          }
          // eslint-disable-next-line jsx-a11y/no-autofocus
          ,
          autoFocus: true,
          categories: categories,
          "data-testid": testid,
          enableAISuggestions: enableAISuggestions,
          getSearchSuggestions: getSearchSuggestions,
          onSearch: onSearch,
          placeholder: "",
          sx: {
            '& .MuiFormControl-root.MuiTextField-root .MuiOutlinedInput-root.Mui-focused': {
              '& .MuiInputAdornment-root .MuiSvgIcon-root': {
                color: "".concat(theme.palette.primary[700])
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: "1px solid ".concat(theme.palette.primary[700])
              },
              boxShadow: 'unset'
            }
          }
        }), /*#__PURE__*/_jsx(StyledButton, {
          onClick: function onClick() {
            return setShowSeachBar(false);
          },
          variant: "newText",
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "bodycopyregular",
            children: translate('ProductSearchResources.Cancel')
          })
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Stack, {
          alignItems: "center",
          direction: "row",
          spacing: "10px",
          children: [/*#__PURE__*/_jsx(StyledIcon, {
            "aria-label": ariaLabelTranslate('Common.Menu'),
            onClick: onMenuButtonClick,
            children: _MenuIcon || (_MenuIcon = /*#__PURE__*/_jsx(MenuIcon, {}))
          }), isLogoClickable ? /*#__PURE__*/_jsx(StyledLink, {
            "aria-label": ariaLabelTranslate('Common.GoToHomePage'),
            to: "/home",
            children: _IngramLogoWithoutR || (_IngramLogoWithoutR = /*#__PURE__*/_jsx(IngramLogoWithoutR, {
              height: "12.77px",
              width: "160px"
            }))
          }) : _IngramLogoWithoutR2 || (_IngramLogoWithoutR2 = /*#__PURE__*/_jsx(IngramLogoWithoutR, {
            height: "12.77px",
            width: "160px"
          }))]
        }), /*#__PURE__*/_jsx(StyledIcon, {
          "aria-label": ariaLabelTranslate('Common.Search'),
          onClick: function onClick() {
            return setShowSeachBar(true);
          },
          children: _SearchIcon || (_SearchIcon = /*#__PURE__*/_jsx(SearchIcon, {}))
        })]
      })
    })
  });
}
var RootStack = styled(Stack)(function (_ref) {
  var theme = _ref.theme;
  return {
    alignItems: 'center',
    borderBottom: "1px solid ".concat(theme.palette.grey[200]),
    height: '52px',
    justifyContent: 'space-between',
    maxWidth: '768px',
    padding: '6px 16px',
    width: '100%'
  };
});
var StyledLink = styled(Link)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    alignItems: 'center',
    display: 'flex'
  };
});
var StyledIcon = styled(IconButton)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    height: '32px',
    width: '32px'
  };
});
var StyledButton = styled(Button)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.palette.primary[700],
    padding: '6px 12px'
  };
});
var StyledPopper = styled(Popper)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    '& .MuiAutocomplete-listbox .MuiAutocomplete-groupLabel': {
      color: theme.palette.grey[800],
      fontSize: '18px',
      fontWeight: 600
    },
    '& .MuiAutocomplete-listbox .MuiAutocomplete-option': {
      minHeight: 'auto'
    },
    '& .MuiAutocomplete-paper': {
      fontSize: '14px',
      lineHeight: '22px'
    },
    maxWidth: '768px !important',
    transform: 'translate3d(0px, 52px, 0px) !important',
    width: '100% !important'
  };
});